/**
 * ResposivePanel
 * 
 * @Author: Focci
 * @Date: 2023-10-11 16:07:20
 * @Last Modified by: Focci
 * @Last Modified time: 2023-10-11 16:07:20
 */

import PropTypes from 'prop-types'
import clsx from 'clsx'
import { delay } from 'lodash-es'
import { useTranslations } from 'next-intl'
import { useCallback, useEffect, useRef, useState } from 'react'
import ResposiveChips, { AutocompleteChipsButton } from './ResposiveChips'
import ResposiveAutocomplete from './ResposiveAutocomplete'

export default function ResposivePanel({
  open,
  changed,
  type,
  value = [],
  className,
  autocompleteProps = {},
  onSubmit = () => {},
  onChange = () => {},
  inputUndersideChild,
  back,
  action,
}) {
  const tc = useTranslations('common')
  const wrapperRef = useRef()
  const inputRef = useRef()

  const [highlight, setHighlight] = useState(null)
  
  const handleKeydown = useCallback((e) => {
    if(e.keyCode !== 13) return
    if(!highlight) {
      value.length > 0 && onSubmit()
    } else {
      setHighlight(null)
    }
  }, [highlight, onSubmit, value])

  // 打开滚动到搜索位置
  useEffect(() => { 
    open && delay(() => {
      const { top } = inputRef.current.getBoundingClientRect()
      wrapperRef.current.scrollTop += (top - 60)
    }, 50) 
  }, [open])

  return (
    <div 
      ref={wrapperRef}
      className={clsx([
        'overflow-y-auto overflow-x-hidden',
        className
      ])}
    >
      <ResposiveAutocomplete
        value={value}
        type={type}
        onChange={onChange}
        onKeyDown={handleKeydown}
        onHighlightChange={(_e, d) => setHighlight(d)}
        {...autocompleteProps}
        inputTopsideChild={
          <div className="flex items-start" ref={inputRef}>
            {back}
            <div className="flex-auto">
              <ResposiveChips 
                data={value}
                onChange={onChange}
              >
                {changed && value.length > 0 && (
                  <AutocompleteChipsButton 
                    onClick={onSubmit}
                    className="bg-primary text-white"
                    label={tc('complete')}
                  />
                )}
              </ResposiveChips>
            </div>
            {action}
          </div>
        }
        inputUndersideChild={inputUndersideChild}
      />
    </div>
  )
}

ResposivePanel.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool,
  changed: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.array,
  autocompleteProps: PropTypes.object,
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  inputUndersideChild: PropTypes.node,
  back: PropTypes.node,
  action: PropTypes.node,
}
